export default __webpack_public_path__ + "static/high_img-10427e2029f625a36c1d0709e9060029.png";